import React, { createContext, useState, ReactNode } from 'react';

// Context for the Seller - ventero/ventero
export interface SellerData {
    nombre_completo: string;
    id_tipo_documento: string;
    documento: string;
    correo_electronico: string;
    actividad: string;
    fecha_vencimiento: string;
    numero_resolucion: string;
    foto_ventero: string;
    telefono: number;
}

interface SellerContextProps {
    seller: SellerData | null;
    setSeller: React.Dispatch<React.SetStateAction<SellerData | null>>;
}

export const SellerContext = createContext<SellerContextProps | undefined>(undefined);

export const SellerProvider = ({ children }: { children: ReactNode }) => {
    const [seller, setSeller] = useState<SellerData | null>(null);

    return (
        <SellerContext.Provider value={{ seller, setSeller }}>
            {children}
        </SellerContext.Provider>
    );
};

// Context for the Module - ventero/persona
interface ModuleData {
    id: string;
    serial_propio: string;
    id_tenencia_propiedad: string;
    id_tipo_modulo: string;
    id_direccion: string;
    id_sector_modulo: string;
    barrio: string;
    nombre1: string;
    nombre2: string;
    apellido1: string;
    apellido2: string;
    documento: string;
    correoElectronico: string;
    telefonoCelular: number | any;
}

interface ModuleContextProps {
    module: ModuleData | null;
    setModule: React.Dispatch<React.SetStateAction<ModuleData | null>>;
}

export const ModuloContext = createContext<ModuleContextProps | undefined>(undefined);

export const ModuloProvider = ({ children }: { children: ReactNode }) => {
    const [module, setModule] = useState<ModuleData | null>(null);

    return (
        <ModuloContext.Provider value={{ module, setModule }}>
            {children}
        </ModuloContext.Provider>
    );
};

// Context for the Capture
interface CaptureContextProps {
    capturedImageC: string | null;
    setCapturedImageC: React.Dispatch<React.SetStateAction<string | null>>;
    hasCapturedImageC: boolean;
}

export const CaptureContext = createContext<CaptureContextProps | undefined>(undefined);

export const CaptureProvider = ({ children }: { children: ReactNode }) => {
    const [capturedImageC, setCapturedImageC] = useState<string | null>(null);

    // hasCapturedImage will be true if capturedImage is not null
    const hasCapturedImageC = capturedImageC !== null;

    return (
        <CaptureContext.Provider value={{ capturedImageC, setCapturedImageC, hasCapturedImageC }}>
            {children}
        </CaptureContext.Provider>
    );
};